export default "__VITE_ASSET__CZh666DY__"